import { IonModal } from "@ionic/react";
import Button from "../../../ui/Button";
import Close from "../../../ui/Close";
import { changeStatusProducts, getToursByID, getToursOperator } from "../../../utils/api";
import { setProducts, setTourFocus } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";

const ModalMakeDraft = (props) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  return (
    <IonModal
      className="modal-make-draft"
      isOpen={props.open}
      onWillDismiss={() => props.onClose(false)}
    >
      <Close onClick={() => props.onClose(false)} />
      <div className="body-modal-make-draft">
        <div className="title">Сделать тур черновиком</div>
        <div className="cont-text">
          <div className="text">
            Если тур опубликован, он будет снят с публикации и переведён в статус «Черновик». Вы
            сможете внести изменения и опубликовать после повторной модерации.
          </div>
        </div>
        <div className="btns">
          <Button typebtn="outline" className="small" onClick={() => props.onClose(false)}>
            Отмена
          </Button>
          <Button
            typebtn="bright"
            className="small"
            onClick={() => {
              changeStatusProducts(token, props.element.id, 1).then(async (e) => {
                if (e.data.errors) {
                } else {
                  await getToursOperator(token).then((e) => {
                    if (e.data.data) {
                      dispatch(setProducts(e.data.data));
                    }
                  });
                  props.fromInfo &&
                    getToursByID(token, props.element.id).then((e) => {
                      dispatch(setTourFocus(e.data.data));
                    });
                }
              });
              props.onClose(false);
            }}
          >
            Подтвердить
          </Button>
        </div>
      </div>
    </IonModal>
  );
};

export default ModalMakeDraft;
